import { render, staticRenderFns } from "./PdfjsViewer.vue?vue&type=template&id=fd6dafee&scoped=true&"
import script from "./PdfjsViewer.vue?vue&type=script&lang=ts&"
export * from "./PdfjsViewer.vue?vue&type=script&lang=ts&"
import style0 from "@/forked-libs/pdfjs-dist/web/pdf_viewer.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./PdfjsViewer.vue?vue&type=style&index=1&id=fd6dafee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6dafee",
  null
  
)

export default component.exports